export default "__VITE_ASSET__CFP8nC7V__"